import { createOneOffPayment } from '@/api/query/payment';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { formatTranslation } from '@/common/utils/formatTranslation';
import { BLIK_FIRST_PAYMENT_METHOD_ORDER } from '@/pages/customer/pawall/stripe/stripePaymentElementOptions';
import PlanPaymentElements from '../../../components/planPayment/PlanPaymentElements';
import { BackButton } from '../../../components/planPayment/PlanPayment.styles';

const createEmbeddedOneOffPayment = (payload) =>
	createOneOffPayment({ ...payload, embedded: true });

const StripeBlikOneOffPayment = ({
	selectedPlan,
	returnPath,
	analyticsSource,
	onBack,
}) => {
	const t = useLanguageData('chat');

	return (
		<>
			<PlanPaymentElements
				selectedPlan={selectedPlan}
				createPayment={createEmbeddedOneOffPayment}
				returnPath={returnPath}
				analyticsSource={analyticsSource}
				submitLabel={formatTranslation(t.planCheckoutPay, {
					price: selectedPlan.price,
				})}
				processingLabel={t.planCheckoutProcessing}
				termsPrefix={t.planCheckoutTermsPrefix}
				billingNote={t.planCheckoutOneOff}
				paymentMethodOrder={BLIK_FIRST_PAYMENT_METHOD_ORDER}
			/>
			<BackButton type='button' onClick={onBack}>
				{t.planCheckoutBlikFallbackBack}
			</BackButton>
		</>
	);
};

export default StripeBlikOneOffPayment;
